// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_SaveInput — body for POST /scheduled-jobs/save.
 *
 * `id` null = create; a positive int = update the existing job (name
 * uniqueness re-checked excluding itself). Either path always resets
 * next_run_at to NULL server-side — a freshly created OR freshly edited job
 * must not fire on a stale/absent schedule value; JobDispatcher reseeds it
 * with the next FUTURE occurrence on the next tick, never executing
 * immediately (see JobSchedule.php docblock).
 *
 * `params` is validated here ONLY for well-formed JSON — the job-type-specific
 * shape (franquia_id, period, task) is validated at RUN time by
 * FaturamentoReportJob / InternalTaskJob, which treat it as hostile,
 * staff-editable input regardless of what this form allowed through.
 */
import { registerContract } from './validate'

export interface ScheduledJobs_SaveInput {
name: string
job_type: string
schedule_kind: string
channel: string
id?: number
enabled?: boolean
schedule_time?: string
interval_minutes?: number
params?: string
channel_target?: string
max_attempts?: number
}

registerContract('ScheduledJobs_SaveInput', {
  name:             { type: 'string',  required: true },
  job_type:         { type: 'string',  required: true },
  schedule_kind:    { type: 'string',  required: true },
  channel:          { type: 'string',  required: true },
  id:               { type: 'number',  required: false },
  enabled:          { type: 'boolean', required: false },
  schedule_time:    { type: 'string',  required: false },
  interval_minutes: { type: 'number',  required: false },
  params:           { type: 'string',  required: false },
  channel_target:   { type: 'string',  required: false },
  max_attempts:     { type: 'number',  required: false },
})
